import { render } from "./SalesByData.vue?vue&type=template&id=0332dfff"
import script from "./SalesByData.vue?vue&type=script&lang=js"
export * from "./SalesByData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__